export default __webpack_public_path__ + "static/media/header_pc@2x.69412c9e.jpg";